import { render, staticRenderFns } from "./decline_competition.vue?vue&type=template&id=1915ddfb&scoped=true&"
import script from "./decline_competition.vue?vue&type=script&lang=js&"
export * from "./decline_competition.vue?vue&type=script&lang=js&"
import style0 from "./decline_competition.vue?vue&type=style&index=0&id=1915ddfb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1915ddfb",
  null
  
)

export default component.exports